import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cart: {},
  order:{} // cart[eventId] will be an object
};

const cartbodySlice = createSlice({
  name: 'cartbody',
  initialState,
  reducers: {
    addServiceToCart: (state, action) => {
      const { eveId, eventname, type, event_start_date, item } = action.payload;
      const eventId = Number(eveId);

      if (!['priestData', 'tentHouseData', 'cateringData'].includes(type)) return;

      if (!state.cart[eventId]) {
        state.cart[eventId] = {
          eventname: eventname || '',
          event_start_date: event_start_date || "",
          priestData: [],
          tentHouseData: [],
          cateringData: [],
        };
      }

      const list = state.cart[eventId][type];

      const itemKey = item.provider_id;

      const existingItemIndex = list.findIndex(
        (i) => i.provider_id === itemKey
      );

      // Prepare item fields
      if (type === 'tentHouseData') {
        item.provider_id = item.provider_id;
        item.providername = item.providername;
        item.services = item.services || [];
        item.Pricing = item.Pricing || {};
        item.balance_to_be_paid = item.balance_to_be_paid;
        item.is_checked_out = item.is_checked_out;
        item.is_edit_allowed = item.is_edit_allowed;
        item.paid_amount = item.paid_amount;

        item.is_cancel_in_progress = item.is_cancel_in_progress;
        item.is_canceled = item.is_canceled;
        item.refund_complete = item.refund_complete;
        item.refund_in_pending = item.refund_in_pending;
        item.refunded_amount = item.refunded_amount;

        item.event_start_date = item.event_start_date;
        item.pricing = item.pricing;

        item.services.forEach((service) => {
          service.mapping_id = service.mapping_id;
          service.service_id = service.service_id;
          service.cart_id = service.cart_id;
          service.quantity = service.quantity;
          service.price = service.price;
          service.discountPrice =
            service.discountPrice !== undefined ? service.discountPrice : null;
          service.validUpto =
            service.validUpto !== undefined ? service.validUpto : null;

        });
        //     console.log('Processed tentHouseData item:', {
        //   provider_id: item.provider_id,
        //   providername: item.providername,
        //   Pricing: item.Pricing,
        //   services: item.services,
        //   // ... other fields
        // });
      }
      if (type === 'cateringData') {
        item.provider_id = item.provider_id;
        item.providername = item.providername;
        item.services = item.services || [];
        item.balance_to_be_paid = item.balance_to_be_paid;
        item.is_checked_out = item.is_checked_out;
        item.is_edit_allowed = item.is_edit_allowed;
        item.paid_amount = item.paid_amount;

        item.is_cancel_in_progress = item.is_cancel_in_progress;
        item.is_canceled = item.is_canceled;
        item.refund_complete = item.refund_complete;
        item.refund_in_pending = item.refund_in_pending;
        item.refunded_amount = item.refunded_amount;

        item.services.forEach((service) => {
          service.mapping_id = service.mapping_id;
          service.service_id = service.service_id;
          service.quantity = service.quantity;
          service.price = service.price;
          service.discountPrice =
            service.discountPrice !== undefined ? service.discountPrice : null;
          service.validUpto =
            service.validUpto !== undefined ? service.validUpto : null;
          service.category = service.category;
          service.mealtype = service.mealtype;
          service.cuisine = service.cuisine;
          service.gst_amount = service.gst_amount;
          service.gst_percentage = service.gst_percentage;
          service.total_amount = service.total_amount;
        });
      }

      if (type === 'priestData') {
        item.cart_id = item.cart_id;
        item.service_id = item.service_id;
        item.price = item.price;
        item.discountPrice =
          item.discountPrice !== undefined ? item.discountPrice : null;
        item.validUpto =
          item.validUpto !== undefined ? item.validUpto : null;

        item.is_checked_out = item.is_checked_out !== undefined ? item.is_checked_out : false;
        item.is_edit_allowed = item.is_edit_allowed !== undefined ? item.is_edit_allowed : false;
        item.paid_amount = item.paid_amount !== undefined ? item.paid_amount : 0;
        item.balance_to_be_paid = item.balance_to_be_paid !== undefined ? item.balance_to_be_paid : 0;

        item.is_cancel_in_progress = item.is_cancel_in_progress;
        item.is_canceled = item.is_canceled;
        item.refund_complete = item.refund_complete;
        item.refund_in_pending = item.refund_in_pending;
        item.refunded_amount = item.refunded_amount;
        item.gstAmount = item.gstAmount;
        item.gstPercentage = item.gstPercentage;
        item.totalAmount = item.totalAmount;

      }

      if (existingItemIndex === -1) {
        // Add new item if not exists
        list.push(item);
      } else {
        // Replace the existing item completely (no merge)
        list[existingItemIndex] = item;
      }
    },

    addServiceToOrder: (state, action) => {
      const { eveId, eventname, type, event_start_date, item } = action.payload;
      const eventId = Number(eveId);

      if (!['priestData', 'tentHouseData', 'cateringData'].includes(type)) return;

      if (!state.order[eventId]) {
        state.order[eventId] = {
          eventname: eventname || '',
          event_start_date: event_start_date || "",
          priestData: [],
          tentHouseData: [],
          cateringData: [],
        };
      }

      const list = state.order[eventId][type];

      const itemKey = item.provider_id;

      const existingItemIndex = list.findIndex(
        (i) => i.provider_id === itemKey
      );

      // Prepare item fields
      if (type === 'tentHouseData') {
        item.provider_id = item.provider_id;
        item.providername = item.providername;
        item.services = item.services || [];
        item.Pricing = item.Pricing || {};
        item.balance_to_be_paid = item.balance_to_be_paid;
        item.is_checked_out = item.is_checked_out;
        item.is_edit_allowed = item.is_edit_allowed;
        item.paid_amount = item.paid_amount;

        item.is_cancel_in_progress = item.is_cancel_in_progress;
        item.is_canceled = item.is_canceled;
        item.refund_complete = item.refund_complete;
        item.refund_in_pending = item.refund_in_pending;
        item.refunded_amount = item.refunded_amount;

        item.event_start_date = item.event_start_date;
        item.pricing = item.pricing;

        item.services.forEach((service) => {
          service.mapping_id = service.mapping_id;
          service.service_id = service.service_id;
          service.order_id = service.order_id;
          service.quantity = service.quantity;
          service.price = service.price;
          service.discountPrice =
            service.discountPrice !== undefined ? service.discountPrice : null;
          service.validUpto =
            service.validUpto !== undefined ? service.validUpto : null;

        });
        //     console.log('Processed tentHouseData item:', {
        //   provider_id: item.provider_id,
        //   providername: item.providername,
        //   Pricing: item.Pricing,
        //   services: item.services,
        //   // ... other fields
        // });
      }
      if (type === 'cateringData') {
        item.provider_id = item.provider_id;
        item.providername = item.providername;
        item.services = item.services || [];
        item.balance_to_be_paid = item.balance_to_be_paid;
        item.is_checked_out = item.is_checked_out;
        item.is_edit_allowed = item.is_edit_allowed;
        item.paid_amount = item.paid_amount;

        item.is_cancel_in_progress = item.is_cancel_in_progress;
        item.is_canceled = item.is_canceled;
        item.refund_complete = item.refund_complete;
        item.refund_in_pending = item.refund_in_pending;
        item.refunded_amount = item.refunded_amount;

        item.services.forEach((service) => {
          service.mapping_id = service.mapping_id;
          service.service_id = service.service_id;
          service.quantity = service.quantity;
          service.price = service.price;
          service.discountPrice =
            service.discountPrice !== undefined ? service.discountPrice : null;
          service.validUpto =
            service.validUpto !== undefined ? service.validUpto : null;
          service.category = service.category;
          service.mealtype = service.mealtype;
          service.cuisine = service.cuisine;
          service.gst_amount = service.gst_amount;
          service.gst_percentage = service.gst_percentage;
          service.total_amount = service.total_amount;
        });
      }

      if (type === 'priestData') {
        item.order_id = item.order_id;
        item.service_id = item.service_id;
        item.price = item.price;
        item.discountPrice =
          item.discountPrice !== undefined ? item.discountPrice : null;
        item.validUpto =
          item.validUpto !== undefined ? item.validUpto : null;

        item.is_checked_out = item.is_checked_out !== undefined ? item.is_checked_out : false;
        item.is_edit_allowed = item.is_edit_allowed !== undefined ? item.is_edit_allowed : false;
        item.paid_amount = item.paid_amount !== undefined ? item.paid_amount : 0;
        item.balance_to_be_paid = item.balance_to_be_paid !== undefined ? item.balance_to_be_paid : 0;

        item.is_cancel_in_progress = item.is_cancel_in_progress;
        item.is_canceled = item.is_canceled;
        item.refund_complete = item.refund_complete;
        item.refund_in_pending = item.refund_in_pending;
        item.refunded_amount = item.refunded_amount;
        item.gstAmount = item.gstAmount;
        item.gstPercentage = item.gstPercentage;
        item.totalAmount = item.totalAmount;

      }

      if (existingItemIndex === -1) {
        // Add new item if not exists
        list.push(item);
      } else {
        // Replace the existing item completely (no merge)
        list[existingItemIndex] = item;
      }
    },

    removeAllCateringData: (state, action) => {
      const { eventId } = action.payload;
      const eid = Number(eventId);

      if (state.cart[eid]) {
        // Simply set cateringData to an empty array
        state.cart[eid].cateringData = [];
      }
    },
    removeCateringServicesByProviderId: (state, action) => {
      const { eventId, providerId } = action.payload;
      const eid = Number(eventId);

      if (!state.cart[eid]?.cateringData) return;

      // Filter out the services for the given providerId
      const updatedProviders = state.cart[eid].cateringData
        .map(provider => {
          if (provider.provider_id !== providerId) return provider;

          // Remove all services for this provider
          return {
            ...provider,
            services: [],
          };
        })
        // Keep only providers that still have services
        .filter(provider => provider.services.length > 0);

      state.cart[eid].cateringData = updatedProviders;
    },


    removeServiceFromCart: (state, action) => {
      const { eventId, type, itemId } = action.payload;
      const eid = Number(eventId);
      if (state.cart[eid]) {
        state.cart[eid][type] = state.cart[eid][type].filter(
          (item) => item.provider_id !== itemId
        );
      }
    },
    removeCateringServiceByMappingId: (state, action) => {
      const { eventId, providerId, mappingId } = action.payload;
      const eid = Number(eventId); // or String(eventId) based on step 2
      console.log("Event ID:", eid);
      console.log("State.cart keys:", Object.keys(state.cart));
      console.log("Full cart:", state.cart);

      const cartEntry = state.cart?.[eid];
      console.log("cartEntry:", cartEntry);

      if (!cartEntry?.cateringData) return;

      const updatedProviders = cartEntry.cateringData
        .map((provider) => {
          if (provider.provider_id !== providerId) return provider;

          const updatedServices = provider.services.filter(
            (service) => service.mapping_id !== mappingId
          );

          return {
            ...provider,
            services: updatedServices,
          };
        })
        .filter((provider) => provider.services.length > 0);

      state.cart[eid].cateringData = updatedProviders;
    }
    ,
    removePriestByCartId: (state, action) => {
      const { eventId, cartId } = action.payload;
      const eid = Number(eventId);
      console.log("got here")
      console.log("Event ID:", eid);
      console.log("State.cart keys:", Object.keys(state.cart));
      console.log("Full cart:", state.cart);
      if (state.cart[eid] && Array.isArray(state.cart[eid].priestData)) {
        state.cart[eid].priestData = state.cart[eid].priestData.filter(
          (item) => item.cart_id !== cartId
        );
      }
    },
    removeTentHouseByProviderId: (state, action) => {
      const { eventId, providerId } = action.payload;
      const eid = Number(eventId);
      console.log(eid, providerId);
      console.log("got here1");
      if (state.cart[eid] && Array.isArray(state.cart[eid].tentHouseData)) {
        console.log("got here2");
        state.cart[eid].tentHouseData = state.cart[eid].tentHouseData.filter(
          (item) => item.provider_id !== providerId
        );
      }
    },


    clearEventCart: (state, action) => {
      const eid = Number(action.payload);
      delete state.cart[eid];
    },

    clearEntireCart: (state) => {
      state.cart = {};
    },

    clearEntireOrder: (state) => {
      state.order = {};
    },
  },
});

export const {
  addServiceToCart,
  addServiceToOrder,
  clearEntireOrder,
  removeServiceFromCart,
  clearEventCart,
  clearEntireCart,
  removeCateringServiceByMappingId,
  removeAllCateringData,
  removePriestByCartId,
  removeCateringServicesByProviderId,
  removeTentHouseByProviderId,
} = cartbodySlice.actions;

export default cartbodySlice.reducer;


// NEW: Selector that counts exactly like Cartbody component
export const selectCartItemsCount = (state) => {
  const cartData = state.cartbodyslice.cart;
  const eventDataMap = state.eventcartdata.eventDetailsById;

  let totalCount = 0;
  const now = new Date();

  Object.entries(cartData).forEach(([eventId, eventDetails]) => {
    // Check if event exists in both cartbody AND eventcartdata
    const hasCartData = !!cartData[eventId];
    const hasEventData = !!eventDataMap[eventId];

    if (!hasCartData || !hasEventData) {
      return;
    }

    const {
      priestData,
      tentHouseData,
      cateringData,
    } = eventDetails;

    // Filter out checked out items
    const activePriestData = priestData?.filter(item => !item.is_checked_out) || [];
    const activeTentData = tentHouseData?.filter(item => !item.is_checked_out) || [];
    const activeCateringData = cateringData?.filter(item => !item.is_checked_out) || [];

    // Get event date from eventDataMap
    const eventdate = eventDataMap[eventId]?.startDate;
    const date = eventdate ? new Date(eventdate) : null;
    const isEventOver = date ? date < now : false;

    // Skip if event is over (past event)
    if (isEventOver) {
      return;
    }

    // Skip if all services are empty
    if (activePriestData.length === 0 && activeTentData.length === 0 && activeCateringData.length === 0) {
      return;
    }

    // Count items for valid events
    const eventCount = activePriestData.length + activeTentData.length + activeCateringData.length;
    totalCount += eventCount;
  });

  return totalCount;
};

export const selectIdentifiersByEventId = (state, eventId) => {
  const eid = Number(eventId);
  const cartEntry = state.cartbodyslice.cart[eid];
  if (!cartEntry) return null;

  // priest → cart_id
  const priestCartIds = cartEntry.priestData?.map(item => item.cart_id) || [];

  // tenthouse → provider_id
  const tentProviderIds = cartEntry.tentHouseData?.map(item => item.provider_id) || [];

  // catering → provider_id + mapping_id
  const cateringDetails = cartEntry.cateringData?.flatMap(provider =>
    provider.services.map(service => ({
      providerId: provider.provider_id,
      mappingId: service.mapping_id,
    }))
  ) || [];

  return {
    priestCartIds,
    tentProviderIds,
    cateringDetails,
  };
};
